module.exports = __webpack_public_path__ + "static/img/register_ercode_new.5be947eb.png";